export default {
  NEW_STOP: 'new_stop',
  EXISTING_STOP: 'existing_stop',
};
